import React from "react"
import { SubscriptionCancellationRoutes } from "./views/cancellation/SubscriptionCancellationRoutes"
import { AppRouteProps, GenericSuspense } from "@harea/component";
import { Outlet } from "react-router-dom";
import { PricingsRoutes } from "../pricings/PricingsRoutes";
import { SubscriptionRenewRoutes } from "./views/renew/SubscriptionRenewRoutes";

const SubscriptionContainer = React.lazy(() => import("./container/SubscriptionContainer"));

export const SubscriptionRoutes: Array<AppRouteProps> = [
    {
        path: "subscription",
        title: "Harea.Billing.Subscription.Title",
        element: (
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        ),
        children: [
            {
                index: true,
                element: <SubscriptionContainer />,
            },
            ...PricingsRoutes,
        ],
    },
    ...SubscriptionCancellationRoutes,
    ...SubscriptionRenewRoutes
]
